import { render, staticRenderFns } from "./RecordDetailSnapshot.vue?vue&type=template&id=26685846&"
import script from "./RecordDetailSnapshot.vue?vue&type=script&lang=js&"
export * from "./RecordDetailSnapshot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports